export function mapPassionsData(passionsData) {
  if (!passionsData) {
    return [];
  }
  return Object.keys(passionsData).map((passion) => ({
    name: passion,
    value: passionsData[passion].value
  }));
}